import * as S from './styles';
import WdLogo from 'base/src/components/WDLogo';
import { Button } from 'base/src/components/Button';

import { Icon } from '@iconify/react/dist/iconify.js';
import { useTheme } from 'base/src/utils/context/themeContext';
import { formatToBRL } from 'base/src/utils/mathUtil';
import Divider from 'base/src/components/Divider';
import { useCarteira } from 'domain/utils/context/carteiraBaseContext';



interface Props {
  valor: number;
  pixComErro?: boolean;
  realizarPagamento: () => void;
  taxas: number;
}

export function PagamentoDestino({ valor, realizarPagamento, pixComErro, taxas }: Props){
  const { walletBalance } = useCarteira();
  const { theme } = useTheme();

  return (
    <S.Container>
      <S.Logo>
        <WdLogo size='50px' />
        <S.TextConainer>
          <S.Title>Carteira WebDecisor</S.Title>
          <S.Subtitle>{formatToBRL(walletBalance || '')} disponível</S.Subtitle>
        </S.TextConainer>
      </S.Logo>
      <S.OverviewContainer>
        <div style={{ justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <S.ValueContainer>
            <S.Subtitle bold>Saldo</S.Subtitle>
            <S.Subtitle blue bold>{formatToBRL(walletBalance || 0)}</S.Subtitle>  
          </S.ValueContainer>
        </div>
        <div style={{ justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
          <S.ValueContainer>
            <S.Subtitle bold>Valor a pagar</S.Subtitle>
            <S.Subtitle red bold>{formatToBRL(valor)}</S.Subtitle>  
          </S.ValueContainer>
          <S.ValueContainer>
            <S.Subtitle bold>Taxas</S.Subtitle>
            <S.Subtitle red bold>{formatToBRL(taxas)}</S.Subtitle>  
          </S.ValueContainer>
        </div>
        <Divider />
        <div style={{ justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <S.ValueContainer>
            <S.Subtitle bold></S.Subtitle>
            <S.Subtitle blue bold>{formatToBRL(Number(walletBalance || 0) - Number(valor) - Number(taxas))}</S.Subtitle>  
          </S.ValueContainer>
        </div>
          {/* <S.Subtitle bold>Subtotal</S.Subtitle>
          <S.Subtitle blue bold>{valor}</S.Subtitle> */}
        {!pixComErro && (
          <S.WarningContainer>
            <S.WarningText>Há chaves PIX invalidas</S.WarningText>
            <Icon icon='si:alert-fill' height={25} color={theme.colors.negative} />
          </S.WarningContainer>
        )}
      </S.OverviewContainer>
      <Button size='lg' full onClick={realizarPagamento} disabled={valor <= 0}>Realizar Pagamento</Button>

    </S.Container >
  )
}
